import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import LazyImage from '../../hocs/Lazy/LazyImage';
import { difference } from '../../utils/array';
import { hasClass } from '../../utils/dom';
import { imageSizeTranslation, productImageSizeTranslation } from '../../utils/image';
import { translate, translateObjectData, prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import { resetFilter } from '../../actions/environment';
import s from './Navigation.scss';

const Navigation = ({ productCache, navigation, pageType, location, setup, menuPopupHeight, openMenuHandler, ...props }) => {
	const [toggledMenuSection, toggleMenuSection] = useState('');
	const [showHoverClear, toggleHoverClear] = useState(false);

	const resetFilterHandler = (e) => {
		const link = e.currentTarget.getAttribute('href');

		if (window.innerWidth > 900) {
			toggleHoverClear(true);
			setTimeout(() => {
				toggleHoverClear(false);
			}, 1000);
		}

		if (window.innerWidth < 900 && toggledMenuSection !== link && hasClass(e.currentTarget, 'u_expandable')) {
			e.preventDefault();
			toggleMenuSection(link);
			return;
		}

		props.resetFilter({ setup, currentPath: location.pathname });
		toggleMenuSection('');
		openMenuHandler();
	};

	const localOpenMenuHandler = (e) => {
		toggleMenuSection('');
		openMenuHandler(e);
	};

	let categories = {};
	let cache = {};

	if (productCache?.[setup.market]?.[setup.pricelist]) {
		const { filterArrays = {}, products } = productCache[setup.market][setup.pricelist];
		if (filterArrays.categories) categories = filterArrays.categories;
		if (products) cache = products;
	}

	return (
		<nav className={s.navigation}>
			<a className={[s.navigation_mobileMenu, (navigation.open ? s.navigation_mobileMenu__open : null)].join(' ')} href="#open-mobile-menu" aria-label="Open mobile menu" onClick={localOpenMenuHandler}><span /><span /></a>
			<div className={s.navigation_inner} style={{ maxHeight: `${menuPopupHeight - 6}px` }}>
				<ul className={s.level1}>
					{
						navigation.header.map((level1) => {
							const level1URI = translate(setup, level1, 'uri');
							const combinedURILevel1 = prefix(setup, level1URI);
							const level1Click = {};
							const level1ColumnClasses = [s.level1_column];
							if (location.pathname.indexOf(combinedURILevel1) === 0 && (pageType === 'category' || pageType === 'product')) level1ColumnClasses.push(s.level1_column__selected);

							level1Click.onClick = resetFilterHandler;

							const matchingProducts = Object.keys(categories)
								.sort((a, b) => {
									if (a.length > b.length) return 1;
									if (a.length < b.length) return -1;
									return a.localeCompare(b);
								})
								.filter((cat) => cat.indexOf(level1.uri) !== -1)
								.reduce((acc, cat) => difference(acc, categories[cat]), [])
								.map((productIds) => cache[productIds]);

							if (level1.type === 'page' && matchingProducts.length > 0) {
								if (toggledMenuSection === combinedURILevel1) level1ColumnClasses.push(s.level1_column__expanded);
								else level1ColumnClasses.push(s.level1_column__expandable);
							}

							return (
								<li className={level1ColumnClasses.join(' ')} key={urlify(combinedURILevel1)}>
									<Link className={[s.level1_column_link, (level1.type === 'page' && matchingProducts.length > 0 ? 'u_expandable' : null), (level1.icon ? s.level1_column_link__withIcon : null)].join(' ')} to={combinedURILevel1} {...level1Click}>
										{/* level1.icon && <LazyImage {...imageSizeTranslation(3, level1.icon, false, false, 300)} /> */}
										<span>{translate(setup, level1, 'title')}</span>
									</Link>
									{
										level1.type === 'page' && matchingProducts.length > 0 && (
											<div className={s.level1_column_subMenu}>
												<div className={s.level1_column_subMenu_items}>
													{
														matchingProducts.filter((p) => !!p).slice(0, 5).map((p) => {
															const product = translateObjectData(setup, p);
															return (
																<Link key={`level2-${product.canonicalUri}`} className={s.level1_column_subMenu_item} to={prefix(setup, product.canonicalUri)} onClick={resetFilterHandler}>
																	{ product.image && <LazyImage {...productImageSizeTranslation(3, product.image[0], false, false, 300)} width="150" /> }
																	<span className={s.level1_column_subMenuItem_caption}>{ product.name }</span>
																</Link>
															);
														})
													}
												</div>
												<Link className={s.level1_column_subMenu_learnMore} to={combinedURILevel1} {...level1Click}>{ translate(setup, 'learnMore') }</Link>
											</div>
										)
									}
								</li>
							);
						})
					}
				</ul>
				{
					navigation?.extraMobile && navigation.extraMobile.length > 0 && (
						<ul className={[s.level1, s.level1__extraMobileMenu].join(' ')}>
							{
								navigation.extraMobile.map((level1) => {
									const level1URI = translate(setup, level1, 'uri');
									const combinedURILevel1 = prefix(setup, level1URI);
									const level1Click = {};
									const level1ColumnClasses = [s.level1_column];
									if (location.pathname.indexOf(combinedURILevel1) === 0 && (pageType === 'category' || pageType === 'product')) level1ColumnClasses.push(s.level1_column__selected);

									level1Click.onClick = resetFilterHandler;

									return (
										<li className={level1ColumnClasses.join(' ')} key={urlify(combinedURILevel1)}>
											<Link className={s.level1_column_link} to={combinedURILevel1} {...level1Click}><span>{translate(setup, level1, 'title')}</span></Link>
										</li>
									);
								})
							}
						</ul>
					)
				}
				{ showHoverClear && <div className={s.navigation_inner_clear} /> }
			</div>
		</nav>
	);
};

const mapState = ({ productCache }, props) => ({ productCache, ...props });

export default hot(module)(connect(mapState, { resetFilter })(Navigation));
